import {
    createRequestFilters,
    ListProviderDocumentsRequest,
    ProviderDisplayDocumentType,
    ProviderDocument,
} from '@enter/core';
import _ from 'lodash';
import { action, observable, runInAction } from 'mobx';
import { DocumentGenerator } from './document.generator';
import { DocumentService } from './document.service';
import { IFeatures, IItemListing, IItemListingRequest } from './root.store';
import { appendTo, parseItemListingRequest } from './util';

export class DocumentStore {
    @observable public documents: ProviderDocument[] = [];

    private features: IFeatures;
    private documentGenerator: DocumentGenerator;
    private documentService: DocumentService = new DocumentService();

    constructor(features: IFeatures, documentGenerator: DocumentGenerator) {
        this.features = features;
        this.documentGenerator = documentGenerator;
    }

    @action
    public async loadDocumentListing(ilr: IItemListingRequest): Promise<IItemListing<ProviderDocument>> {
        const documentTypeFilterSelected = _.some(ilr.filters, filter => (filter.filterId = 'filterDocumentType'));

        const lpgr = ilr2lpgr(ilr);

        if (!documentTypeFilterSelected) {
            lpgr.filterDocumentType = [
                `EQ:${ProviderDisplayDocumentType.PROVIDERCONTRACT}`,
                `EQ:${ProviderDisplayDocumentType.PROVIDERREPORT}`,
                `EQ:${ProviderDisplayDocumentType.BUSINESSW9}`,
            ];
        }

        const listing = await (this.features.isDemo
            ? this.documentGenerator.loadDocumentListing(lpgr)
            : this.documentService.fetchDocumentListing(lpgr));
        if (!listing) {
            throw new Error(`No documents available`);
        }
        const { items } = listing;
        runInAction(() => {
            this.documents = appendTo<ProviderDocument>(this.documents, items);
        });
        return listing;
    }
}

// Convert from IItemListingRequest to ListProviderDocumentsRequest
export const ilr2lpgr = (ilr: IItemListingRequest): ListProviderDocumentsRequest => {
    const base = parseItemListingRequest(ilr) as ListProviderDocumentsRequest;
    const filters = createRequestFilters(_.get(ilr, 'filters'), true);
    return {
        ...base,
        ...filters,
    };
};
